globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};
appCustomerSpace.Controllers.LocalManagement.Multicast = appCustomerSpace.Controllers.LocalManagement.Multicast || {};


appCustomerSpace.Controllers.LocalManagement.Multicast.GoogleMybusinessController = (function(superClass) {

    utils.extend(GoogleMybusinessController, superClass);

    function GoogleMybusinessController() {
      return GoogleMybusinessController.__super__.constructor.apply(this, arguments);
    }

    $.extend(GoogleMybusinessController.prototype, {
        init: function() {
          this.initEvents();

          return GoogleMybusinessController.__super__.init.apply(this, arguments);
        },
        initEvents: function() {
          $('input[name=accept_multicast').on('change', function() {
            $('.enable-multicast').attr('disabled', !$(this).is(':checked'));
          });
        }
    });

    return GoogleMybusinessController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
